'use client';

import { createContext } from 'react';
import type { Key } from '@react-types/shared';

export type MenuSubmenuTriggerMode = 'hover' | 'click';

export type MenuSubmenuContextValue = {
    getSubmenuTriggerMode: (key: Key | undefined) => MenuSubmenuTriggerMode | undefined;
    registerSubmenuTriggerMode: (key: Key, mode: MenuSubmenuTriggerMode) => () => void;
};

export const MenuSubmenuContext = createContext<MenuSubmenuContextValue>({
    getSubmenuTriggerMode: () => undefined,
    registerSubmenuTriggerMode: () => () => undefined,
});
